<template>
  <div class="blade-activity">
    <div class="headers">
      <h2
        v-for="(header, i) in headers"
        v-html="header.text"
        :key="`activity-header-${i}`"
      ></h2>
    </div>
    <div class="images">
      <div class="first-col">
        <img
          v-for="(img, i) in imagesFirstCol"
          :key="`activity-img-left-col-${i}`"
          :src="require(`@/assets/moment-activities/${img.src}`)"
        />
      </div>
      <div class="last-col">
        <img
          v-for="(img, i) in imagesLastCol"
          :key="`activity-img-right-col-${i}`"
          :src="require(`@/assets/moment-activities/${img.src}`)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "blade-activity",
  props: ["moments", "length"],
  computed: {
    headers() {
      return this.moments.headers;
    },
    imagesFirstCol() {
      return this.moments.images.firstCol;
    },
    imagesLastCol() {
      return this.moments.images.lastCol;
    },
  },
};
</script>

<style scoped lang="scss">
.blade-activity {
  position: absolute;
  .headers {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    margin-top: auto;
    margin-bottom: auto;
    h2 {
      opacity: 0;
      position: absolute;
      background: #000000;
      margin-top: auto;
      margin-bottom: auto;
      z-index: 100;
      color: #ffffff;
      line-height: 1;
      padding: 0.8285714286em;
      font-size: 3.645833333vw;
      @media screen and (min-width: map-get($grid-breakpoints, xxl)) {
        padding: 58px;
        font-size: 70px;
      }
    }
  }
  .images {
    img {
      object-fit: cover;
      width: 100%;
      height: 100vh;
    }
    & > div {
      width: 50%;
    }
    .first-col {
      float: left;
    }
    .last-col {
      float: right;
    }
  }
}
</style>
